// 数字、金额、日期的显示格式。
// 注意（文档 21 §5 C1/C2）：这里只管「显示」。开放写之前，日期与金额的序列化要抽成新旧前端共享的模块，
// v2 不许自己实现一套提交格式。

export function num(v: unknown): number {
  if (typeof v === 'number') return v;
  if (typeof v === 'string') return Number(v) || 0;
  return 0;
}

const moneyFmt = new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export function money(v: unknown) {
  return `￥${moneyFmt.format(num(v))}`;
}

/** 数量：整数不带小数，非整数最多 3 位（与服务端 quantity() 的 toFixed(3) 一致） */
export function qty(v: unknown) {
  const n = num(v);
  return Number.isInteger(n) ? String(n) : String(Number(n.toFixed(3)));
}

function pad(n: number) {
  return String(n).padStart(2, '0');
}

/** 服务端存的是 UTC 时刻，按本地（北京时间）显示 */
export function date(v?: string | null) {
  if (!v) return '—';
  const d = new Date(v);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
export function shortDate(v?: string | null) {
  if (!v) return '—';
  const d = new Date(v);
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
export function dateTime(v?: string | null) {
  if (!v) return '—';
  const d = new Date(v);
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** 距离交货期还有几天（按本地日历日算）；负数为逾期 */
export function daysUntil(v?: string | null, now = new Date()) {
  if (!v) return null;
  const d = new Date(v);
  const a = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  const b = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((a - b) / 86400000);
}

export function relativeTime(v?: string | null, now = new Date()) {
  if (!v) return '';
  const diff = (now.getTime() - new Date(v).getTime()) / 1000;
  if (diff < 60) return '刚刚';
  if (diff < 3600) return `${Math.floor(diff / 60)} 分钟前`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} 小时前`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} 天前`;
  return shortDate(v);
}
